const createQuery = () => `
query Search($url: String!, $searchTerm: String, $sort: String, $page:Int) {
  instance(url: $url) {
    _id
    slug
    languageCode
    translations {
      key
      value
    }
    translationOptions {
      name
      languageCode
      slug
      flagUrl
    }
  }
  search(url: $url, searchTerm:$searchTerm, sort:$sort, page:$page) {
    results {
      id
      title
      type
      date
      slug
      sell
      images {
        thumbnail_16x9_640 {
          url
          caption
          link
        }
        thumbnail_16x9_448 {
          url
          caption
          link
        }
        thumbnail_16x9_320 {
          url
          caption
          link
        }
      }
    }
    total
    page
    pageSize
  }
}
`

export default createQuery
